import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: 5,
    government: 5,
    office: 5,
  },
  education: {
    childcare: 5,
    high_school: 5,
    library: 5,
    primary: 5,
    university: 5,
  },
  essentials: {
    electricity: 10,
    gas: 10,
    sewers: 10,
    waste: 10,
    water: 10,
  },
  food: {
    bakery: 10,
    coffee: 10,
    fast_food: 10,
    restaurant: 10,
  },
  health: {
    clinic: 10,
    dentist: 10,
    hospital: 10,
    pharmacy: 10,
  },
  nature: {
    beach: 0,
    forest: 0,
    lake: 0,
    mountain: 0,
    park: 0,
    river: 0,
  },
  religion: {
    church: 0,
    mosque: 0,
  },
  shops: {
    grocery: 10,
    mall: 10,
  },
  soil: {
    clay: 0,
    loam: 0,
    peat: 0,
    salt: 0,
    sand: 0,
    silt: 0,
  },
  sport: {
    gym: 10,
    pool: 10,
  },
  telecom: {
    cable_tv: 10,
    fiber_optic: 10,
    network_4g: 10,
    network_5g: 10,
    phone: 10,
  },
  transport: {
    airport: 10,
    bus: 10,
    ferry: 10,
    gas_station: 10,
    metro: 10,
    parking: 10,
    taxi: 10,
    train: 10,
    tram: 10,
  },
};

export default PLACES_PROFILE;
